import { userFields } from '@openx/components-administration/lib/constants.ts';
import type { UserData } from '@openx/components-administration/lib/utils/context/UserHookTypes.ts';
import type { UserFormData } from '@openx/components-administration/types.ts';
import { OPEN_AUDIENCE_ORG_EXTERNAL_ID } from '@openx/utils/services/config.ts';

export const transformDataToMatchUserForm = (data: UserData): UserFormData => {
  const { account, email_address, first_name, last_name, role } = data;

  return {
    [userFields.FIRST_NAME]: first_name,
    [userFields.LAST_NAME]: last_name,
    [userFields.EMAIL]: email_address,
    [userFields.ACCOUNT]: account ? { id: account?.id, name: account?.name } : null,
    [userFields.ROLE]: role as UserFormData['role'],
  };
};

export const isAdminRoleAllowed = (account: { id?: string } | null | undefined) =>
  account?.id === OPEN_AUDIENCE_ORG_EXTERNAL_ID;
